export default __webpack_public_path__ + "static/media/on_2.82ee2778.mp3";